import className from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {isKeyClick} from '../../../scripts/utils';

export default class AccordiItemTitle extends Component {

  render() {
    return (
      <span aria-controls={`accorditabs-item-body-${this.props.id}`}
        className={className('c-accorditabs__title', this.props.className)}
        id={`accorditabs-title-${this.props.id}`}
        onClick={this.props.onClick}
        onKeyPress={(e) => {
          isKeyClick(e) ? this._handleClick() : null;
        }}
        tabIndex="0"
      >
        {this.props.title}
      </span>
    );
  }
}

AccordiItemTitle.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    id: PropTypes.string
};



// WEBPACK FOOTER //
// ./webapp/components/elements/AccordiTab/AccordiItemTitle.js